export default "__VITE_ASSET__DUkLAWjL__"